import { render, staticRenderFns } from "./select-semanas-ano.vue?vue&type=template&id=50c0a5d1"
import script from "./select-semanas-ano.vue?vue&type=script&lang=js"
export * from "./select-semanas-ano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports